export default __webpack_public_path__ + "static/media/oxxo-pay.ab3f1915.png";